export default [
  {
    path: '/ci/sended',
    name: 'CI - Enviados',
    component: () => import('./SendedCi.vue'),
    meta: {
      requiresAuth: true,
      is_admin: true,
      name: 'SendedCi',
    },
  },
]
